import { Card } from "@/components/ui/card";

const Terms = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-8">Terms & Conditions</h1>
      
      <Card className="p-6 space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
          <p className="text-muted-foreground">
            By accessing and using SabiTradeNG, you accept and agree to be bound by the terms and provision of this agreement.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Use of Platform</h2>
          <p className="text-muted-foreground">
            SabiTradeNG provides a WhatsApp commerce platform connecting buyers and sellers. Users must provide accurate information and maintain the security of their accounts.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Seller Responsibilities</h2>
          <p className="text-muted-foreground">
            Sellers are responsible for the accuracy of product listings, timely fulfillment of orders, and compliance with all applicable laws and regulations.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Buyer Responsibilities</h2>
          <p className="text-muted-foreground">
            Buyers must provide accurate delivery information and make timely payments for orders placed through the platform.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Payment Terms</h2>
          <p className="text-muted-foreground">
            All payments are processed securely through our integrated payment system. Funds are held in escrow until order completion.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Dispute Resolution</h2>
          <p className="text-muted-foreground">
            Any disputes between buyers and sellers will be mediated through our customer support team according to our dispute resolution policy.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Limitation of Liability</h2>
          <p className="text-muted-foreground">
            SabiTradeNG shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the platform.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">8. Changes to Terms</h2>
          <p className="text-muted-foreground">
            We reserve the right to modify these terms at any time. Continued use of the platform constitutes acceptance of modified terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">9. Prohibited Items</h2>
          <p className="text-muted-foreground mb-3">
            In compliance with Nigerian laws and regulations, the following items are strictly prohibited from being listed or sold on SabiTradeNG:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-2">
            <li><strong>Illegal Drugs & Narcotics:</strong> Cannabis, cocaine, heroin, and all substances controlled under the National Drug Law Enforcement Agency (NDLEA) Act</li>
            <li><strong>Weapons & Ammunition:</strong> Firearms, explosives, machetes intended for violence, and any items regulated under the Firearms Act</li>
            <li><strong>Counterfeit & Pirated Goods:</strong> Fake branded products, pirated software, movies, music, and items violating intellectual property rights</li>
            <li><strong>Stolen Property:</strong> Any goods obtained through theft, fraud, or illegal means</li>
            <li><strong>Human Trafficking Materials:</strong> Any items or services related to human trafficking or exploitation</li>
            <li><strong>Pornographic Content:</strong> Obscene materials, child exploitation content, and items violating the Cybercrimes Act 2015</li>
            <li><strong>Endangered Wildlife Products:</strong> Ivory, pangolin scales, and products from protected species under CITES and Nigerian wildlife laws</li>
            <li><strong>Unregistered Pharmaceuticals:</strong> Medications not approved by NAFDAC, expired drugs, and controlled substances without proper licensing</li>
            <li><strong>Hazardous Materials:</strong> Toxic chemicals, radioactive materials, and substances harmful to public health</li>
            <li><strong>Government-Restricted Items:</strong> Military uniforms, police equipment, and items restricted for civilian use</li>
            <li><strong>Fraudulent Documents:</strong> Fake IDs, certificates, licenses, or any forged official documents</li>
            <li><strong>Substandard Goods:</strong> Products that fail to meet Standards Organisation of Nigeria (SON) requirements</li>
          </ul>
          <p className="text-muted-foreground mt-3">
            Violation of these prohibitions will result in immediate account suspension, removal of listings, and may be reported to relevant Nigerian authorities including EFCC, NDLEA, and Nigeria Police Force.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">10. Contact Information</h2>
          <p className="text-muted-foreground">
            For questions about these Terms & Conditions, please contact us at support@sabitradeng.com
          </p>
        </section>
      </Card>
    </div>
  );
};

export default Terms;